import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { readMailbox, readMailboxes, getMonitorStatus } from "../services/mailboxApi";

export function useMailboxQuery(publicId, isOpen) {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["mailbox", publicId],
    queryFn: () => readMailbox(publicId),
    enabled: isOpen && !!publicId,
    gcTime: 0,
    onError: (error) => {
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });
}

export function useMailboxesQuery() {
  return useQuery({
    queryKey: ["mailboxes"],
    queryFn: () => readMailboxes(),
  });
}
